<template>
  <div>
    <swiper ref="pcslide"  
      :options="swiperOptions"
      >
      <swiper-slide v-for="(item, idx) in swiperImages" :key="idx">
        <img :src="item" alt="" width="100%"/>
        <!-- 1.516rem -->
      </swiper-slide>
    </swiper>
    <div v-if="paginationLeft" class="prev-btn nav-btn"></div>
    <div v-if="paginationRight" class="next-btn nav-btn"></div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
let vm=null;
export default {
  name: "SysSwiperPc",
  components: { swiper, swiperSlide },
  props: {
    propsData:{
      type:Object,
      default:()=>{}
    },
    initialSlide: {
      type:Number,
      default:0
    },
    paginationRight: {
      type: Boolean,
      default: false
    },
    paginationLeft: {
      type: Boolean,
      default: false
    },
    swiperImages: {
      type: Array
    }
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 2,
        spaceBetween: 0,
        speed: 1000,
        loop: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        },
        navigation: {
          nextEl: ".next-btn",
          prevEl: ".prev-btn"
        },
        on:{
          slideChange(){
            vm.activeIndex = this.activeIndex
            vm.$emit('changeHandle',vm.activeIndex)
          },
        }
      },
    }
  },
  computed:{
    swiper(){
      return this.$refs.pcslide&&this.$refs.pcslide.swiper;
    }
  },
  created(){
    vm = this;
    this.swiperOptions = {...this.swiperOptions, ...this.propsData,initialSlide:this.initialSlide}
  },
  mounted(){
  },
  methods:{
    slideTo(index){
      this.swiper&&this.swiper.slideTo(index);
    },
    slidePrev(){
      this.swiper&&this.swiper.slidePrev();
    },
    slideNext(){
      this.swiper&&this.swiper.slideNext();
    }
  },
}
</script>

<style scoped>
.nav-btn {
  width: 0.32rem;
  height: 0.613rem;
  position: absolute;
  top: calc(50% - 35px);
  cursor: pointer;
  background-size: 100% 100%;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  color: #707070;
}

.prev-btn {
  left: -40px;
  background-image: url("../../assets/sport7/btn-prev.svg");
}

.next-btn {
  right: -40px;
  background-image: url("../../assets/sport7/btn-next.svg");
}
</style>



// WEBPACK FOOTER //
// src/components/common/SysSwiperPc.vue